export default __webpack_public_path__ + "static/Mallory-Medium-f162233c3b71f1f11d8a2b00d01051b1.woff2";